export default __webpack_public_path__ + "static/pharmacy-management-system-development-efb9f3f14977b5bdf23e30e4eceb71e7.jpg";